module.exports = __webpack_public_path__ + "static/p_sara-v-84ca59d16185c3fe5224ad0d1f5a248c.jpg";